import React from 'react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { ArrowRight } from 'lucide-react';

export default function MainichiNaviAI() {
    return (
        <div className="min-h-screen bg-gradient-to-b from-blue-50 to-green-50 p-6">
            <header className="text-center py-10">
                <img
                    src="./logo192.png"
                    alt="毎日ナビAIのイメージキャラクター"
                    className="mx-auto w-32 h-auto mb-4"
                />
                <h1 className="text-4xl font-bold text-blue-700">毎日ナビAI</h1>
                <p className="text-lg text-gray-700 mt-4">発達障害の方向け、日々のタスク管理をサポートするAIツール</p>
            </header>

            <main className="grid gap-10 md:grid-cols-2 lg:grid-cols-2 max-w-5xl mx-auto">
                <Card className="bg-white shadow-lg rounded-2xl p-6">
                    <CardContent>
                        <h2 className="text-2xl font-semibold text-blue-600">おしゃべりスケジュール</h2>
                        <p className="mt-4 text-gray-600">会話からスケジュールを自動でGoogleカレンダーに登録するアプリ。</p>
                        <a
                            href="https://script.google.com/macros/s/AKfycbwj7Gyvay2-bzaBi5nZhjQ3A3kAsOZsWB5BBtg8Hb64OJgbPa9jGuxDk7Mmcowl9sSf/exec"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button className="mt-6 w-full bg-blue-500 text-white hover:bg-blue-600 flex items-center justify-center">
                                アプリを使う <ArrowRight className="ml-2" />
                            </Button>
                        </a>
                    </CardContent>
                </Card>

                <Card className="bg-white shadow-lg rounded-2xl p-6">
                    <CardContent>
                        <h2 className="text-2xl font-semibold text-green-600">やること先生AI</h2>
                        <p className="mt-4 text-gray-600">登録されたタスクをAIが自動で優先度付けし、効率的に管理。</p>
                        <a
                            href="https://script.google.com/macros/s/AKfycbwi5UP280w6e1pqO6CfxjOu499UIFXn6Ome5lRo7ZiqtBOwJocdbxn-ApQURcXHU34I/exec"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <Button className="mt-6 w-full bg-green-500 text-white hover:bg-green-600 flex items-center justify-center">
                                アプリを使う <ArrowRight className="ml-2" />
                            </Button>
                        </a>
                    </CardContent>
                </Card>
            </main>

            <section className="mt-16 text-center">
                <h2 className="text-xl font-semibold text-gray-700 mb-6">Googleサービスへのリンク</h2>
                <div className="grid gap-4 md:grid-cols-2 max-w-md mx-auto">
                    <a href="https://calendar.google.com/" target="_blank" rel="noopener noreferrer">
                        <Button className="w-full bg-blue-500 text-white hover:bg-blue-600">
                            Googleカレンダーを開く
                        </Button>
                    </a>
                    <a href="https://tasks.google.com/embed/list/~default" target="_blank" rel="noopener noreferrer">
                        <Button className="w-full bg-green-500 text-white hover:bg-green-600">
                            Google ToDoを開く
                        </Button>
                    </a>
                </div>
            </section>

            <section className="mt-20 max-w-5xl mx-auto bg-white border rounded-lg p-6 shadow-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">おしゃべりスケジュールマニュアル</h2>
                <p className="mb-6 text-gray-600">
                    以下のマニュアルをご覧いただくと、「おしゃべりスケジュール」の使い方がわかりやすくなります。
                </p>
                <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vTO7jjK27wIVFVmc_CthwDw6WTlmD351QH07d99RV5TPqKHGUIjfk3dO3Ndg-Di20PhWaiWIO-YrCuA/pubembed?start=false&loop=false&delayms=3000" frameborder="0" width="960" height="569" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
            </section>

            <section className="mt-20 max-w-5xl mx-auto bg-white border rounded-lg p-6 shadow-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">やること先生AIマニュアル</h2>
                <p className="mb-6 text-gray-600">
                    以下のマニュアルをご覧いただくと、「やること先生AI」の使い方がわかりやすくなります。
                </p>
                <iframe src="https://docs.google.com/presentation/d/e/2PACX-1vSmWrmUckujeIkTIOstLvwLM21OtswbWEOXPRwlQWwVb2txFjN7-1pNV8RAZxWkpPVvKZb_pkBbX2b0/pubembed?start=false&loop=false&delayms=3000" frameborder="0" width="960" height="569" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true"></iframe>
            </section>


            <section className="mt-20 max-w-3xl mx-auto bg-yellow-50 border border-yellow-300 rounded-xl p-4 text-sm text-yellow-800">
                <p>
                    本アプリでは、GoogleのAIサービス（Gemini API）を使用してテキストの要約や分析を行っています。<br />
                    入力された内容はGoogleに送信され、品質改善の目的で利用される可能性があります。<br />
                </p>
            </section>

            <section className="mt-20 max-w-3xl mx-auto bg-white border-l-4 border-blue-300 p-6 shadow-md text-gray-800 text-base leading-relaxed">
                <h2 className="text-xl font-semibold text-blue-600 mb-4">ロゴに込めた思い</h2>
                <p className="mb-2">
                    ロゴのモチーフになった<strong>コウモリ</strong>は、目の見えにくい生き物です。
                </p>
                <p className="mb-2">
                    ですが<strong>エコーロケーション</strong>という能力を使って、暗闇の中でも
                    <strong>目が見えないというハンディキャップを克服</strong>しています。
                </p>
                <p className="mb-2">
                    私たちも同じように、日々工夫しながら自分のハンディキャップと向き合い、生きています。
                </p>
                <p className="mb-2">
                    そんな工夫の手助けになるアプリが<strong>「毎日ナビAI」</strong>です。
                </p>
                <p className="mt-4 italic text-blue-700">
                    「毎日ナビAI」があなたの生活の支えになりますように。
                </p>
            </section>

            <br />

            <div style={{ textAlign: 'center' }}>
            <a
                href="https://mslab.site/%e6%af%8e%e6%97%a5%e3%83%8a%e3%83%93ai_3dcg/"
                target="_blank"
                rel="noopener noreferrer"
            >
                おまけの3DCG（実験中）
            </a>
            </div>


            <footer className="text-center py-10 text-gray-600 mt-10 text-sm">
                <p>© 2025 毎日ナビAI - 全ての人が毎日を楽しく過ごせるように。</p>
            </footer>
        </div>
    );
}
